import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Sayfa Bulunamadı" description="Aradığınız sayfa bulunamadı." path="/404" noindex />
      <main className="container-shule min-h-[60vh] py-24 flex flex-col items-center justify-center text-center">
        <p className="eyebrow">404</p>
        <h1 className="mt-3 font-serif text-4xl sm:text-6xl text-shule-coffee">Bu sayfa artık burada değil.</h1>
        <p className="mt-5 max-w-xl text-shule-mocha">Aradığınız ürün veya sayfa taşınmış olabilir. Shule dünyasını keşfetmeye ana sayfadan devam edebilirsiniz.</p>
        <Link to="/" className="btn-primary-shule mt-8">Ana Sayfaya Dön</Link>
      </main>
    </>
  );
}
